import React from "react";
import axios from "axios";
import moment from "moment";

import {
  locationCode,
  cardType,
  getPostResult,
  autopayBit,
  locationObject,
  sessionObject,
  pendingPaymentObject,
  getTenantLease,
  tenantProfile,
} from "../../../Utils/Common";
import {
  addFeesToLease,
  addTenantNotes,
  getCurrentDues,
  getTenantUnitLeaseDetails,
  // testXLinkEMVResult as _testXLinkEMVResult
} from "../../../Utils/data";
import { isValidPayment, makePayment, confirmAlertShow } from "../../../Utils/paygateway";
import { updateTransactionStatus, TRANSACTION_STATUS, getOrCreateOrderId } from "../../../Utils/transactionStatus";
import ProcessPaymentRetry from "../../../Utils/ProcessPaymentRetry";
import ConfirmPaymentPlaceholder from "../../../shared/ConfirmPaymentPlaceholder";

class OnlineConfirmPayment extends ProcessPaymentRetry {
  async componentDidMount() {
    const result = getPostResult();
    
    // Get order ID - use from result if available, otherwise from session
    const orderId = result.orderId || getOrCreateOrderId('existing_tenant_order_id');

    // Update status to IFRAME_SUBMITTED (user submitted payment form in iframe)
    await updateTransactionStatus(orderId, TRANSACTION_STATUS.IFRAME_SUBMITTED, {
      step: 'iframe_submitted',
      order_id: result.orderId,
    });

    const isValid = isValidPayment(
      result,
      async () => {
        // Update status to FAILED if payment was cancelled
        await updateTransactionStatus(orderId, TRANSACTION_STATUS.FAILED, {
          step: 'payment_cancelled',
        });
        this.props.history.push("/online-payment-method?retry=true");
      },
      async () => {
        // Update status to FAILED if payment validation failed
        await updateTransactionStatus(orderId, TRANSACTION_STATUS.FAILED, {
          step: 'payment_validation_failed',
          error: result.responseDescription,
        });
        this.props.history.push("/online-payment-method?retry=true");
      }
    );

    if (!isValid) {
      const loginObj = sessionObject();
      addTenantNotes(locationCode(), loginObj.id, "Kiosk Payment Failure: " + result.responseDescription);
      return;
    }

    const requestBody = {
      location_code: locationCode(),
      orderId: result.orderId || orderId,
    };

    makePayment(
      requestBody,
      async (err) => {
        // Update status to FAILED
        await updateTransactionStatus(orderId, TRANSACTION_STATUS.FAILED, {
          step: 'make_payment_failed',
          error: err,
        });
        window.location.href = "/online-payment-method?retry=true";
      },
      (responseData) => {
        this.processPayment(responseData);
      }
    );
  }

  processPayment = async (transactionData) => {
    const loginObj = sessionObject();
    const mylocation = locationObject();
    const paymentObject = pendingPaymentObject();
    const profile = tenantProfile();

    const currentDues = await getCurrentDues(locationCode(), paymentObject.leaseNumber, loginObj.id);
    const keys = Object.keys(currentDues);
    const lastKey = keys[keys.length - 1];
    const latestItem = currentDues[lastKey]?.[0];
    const hasCCFeeInLedger = latestItem?.Activity?.some(item =>
      item.includes("Credit Card Processing Fee")
    );

    const autopayBit = parseInt(sessionStorage.getItem("autopay_bit"));
    let ccFeeStatus = parseInt(sessionStorage.getItem('cc_fee_status'));
    let ccFeeAmount = parseFloat(sessionStorage.getItem('cc_fee_amount'));
    let ccFeeId = sessionStorage.getItem('cc_fee_id');
    
    let amount = parseFloat(paymentObject.rent)

    if(autopayBit === 0 && ccFeeStatus == 1) {
      amount = transactionData.APPROVEDAMOUNT[0];

      if (!hasCCFeeInLedger) {
        await addFeesToLease(locationCode(), paymentObject.leaseNumber, ccFeeId, ccFeeAmount);
      }
    }

    const requestBody = {
      location_code: locationCode(),
      tenant_id: loginObj.id,
      unit_id: paymentObject.unitID,
      amount: amount,
      pay_periods: parseInt(paymentObject.prePayPeriods),
      payment_method: "CC",
      cc_type: cardType(transactionData.CARDBRAND[0]),
      cc_no: transactionData.MASKEDCARDNUMBER[0],
      cc_expiration_date: `${transactionData.EXPMONTH[0]}/${2000 + transactionData.EXPYEAR[0] * 1}`,
      cc_address: profile.address,
      cc_postal_code: profile.zip,
      cc_name: `${profile.firstName} ${profile.lastName}`,
      transaction_id: transactionData.TRANSACTIONID[0],
      cc_response_code: transactionData.RESPONSECODE[0],
      autopay_bit: autopayBit(),
      order_id: transactionData.ORDERID[0],
      token: transactionData.ALIAS[0],
      auction_proceeds: 0,
    };

    this.handleProcessPaymentAPI(
      requestBody,
      async () => {
        // success case - mark as COMPLETED
        const orderId = requestBody.order_id || getOrCreateOrderId('existing_tenant_order_id');
        await updateTransactionStatus(orderId, TRANSACTION_STATUS.COMPLETED, {
          step: 'payment_flow_completed',
          lease_number: paymentObject.leaseNumber,
        });

        const lease = getTenantLease();
        const tenantInfo = sessionObject();
        getTenantUnitLeaseDetails(locationCode(), loginObj.id, paymentObject.leaseNumber).then((newLease) => {
          const params = {
            full_name: `${tenantInfo.first}, ${tenantInfo.last}`,
            unit_number: lease.unitNumber,
            receipt_number: transactionData.ORDERID[0],
            payment_date: moment().format("L"),
            amount_due_before_payment: lease.currentBalanceDue,
            account_balance_if_negative_after_payment: newLease.CurrentBalanceDue[0],
            amount_paid: transactionData.APPROVEDAMOUNT[0],
            paid_thru_date: newLease.PaidThroughDate[0],
            location_phone: mylocation.phone,
            email: lease.tenantEMail,
          };
          axios.post("/api/notices/receipt", params);
        });

        this.props.history.push("/unit-lease-details#paid");
      },
      (result) => {
        // this will handle like incorrect digit check CC
        confirmAlertShow("", result);
      },
      () => {},
      true
    );
  };

  render() {
    return <ConfirmPaymentPlaceholder />;
  }
}

export default OnlineConfirmPayment;
